module.exports = __webpack_public_path__ + "img/change-password.c74a2f61.svg";